import {
  CCP_SOFTPHONE_ROUTE_PATH,
  CCP_SOFTPHONE_SESSION_CHANNEL_NAME,
  CCP_SOFTPHONE_SESSION_EXPIRED_MESSAGE,
} from './types'

/**
 * Whether the current window is the dedicated softphone popup — used to
 * special-case auth-failure handling so this window never redirects itself
 * away from a live call. See CT-821.
 */
export function isCcpSoftphoneWindow(): boolean {
  return window.location.pathname === CCP_SOFTPHONE_ROUTE_PATH
}

/**
 * Tells main tabs that the softphone popup's session has expired (thymebox's
 * own Auth0 session, or the Amazon Connect Streams session), so they can
 * prompt the agent to reopen a fresh, re-authenticated popup. See CT-821.
 */
export function notifySoftphoneSessionExpired(): void {
  if (!('BroadcastChannel' in window)) {
    return
  }
  new BroadcastChannel(CCP_SOFTPHONE_SESSION_CHANNEL_NAME).postMessage(
    CCP_SOFTPHONE_SESSION_EXPIRED_MESSAGE
  )
}

/**
 * Listens for the softphone popup's "session expired" signal. Returns a
 * cleanup function that closes the channel. See CT-821.
 * @param onExpired
 */
export function onSoftphoneSessionExpired(onExpired: () => void): () => void {
  if (!('BroadcastChannel' in window)) {
    return () => {}
  }
  const channel = new BroadcastChannel(CCP_SOFTPHONE_SESSION_CHANNEL_NAME)
  channel.onmessage = (event) => {
    if (event.data === CCP_SOFTPHONE_SESSION_EXPIRED_MESSAGE) {
      onExpired()
    }
  }
  return () => channel.close()
}
